	<div class="kiosk-confirm-background">
		<div id="kiosk-container">
			<div id="print-confirm-header-label-text">{{ 'kiosk.sentToPrinter' | translate }}</div>
			<div id="print-confirm-label-text">
				<h4 style="color: white; font-size: 40px">
					{{ 'kiosk.checkThePrinter' | translate }}
					<div *ngIf="remainingSeconds">
						{{ 'kiosk.restartInSeconds' | translate: {'remainingSeconds': remainingSeconds} }}
					</div>
				</h4>
			</div>
		</div>
		<ion-button (click)="startOver()" id="start-over-btn">
			{{ 'kiosk.startOver' | translate }}
		</ion-button>
	</div>
	<div class="kiosk-confirm-image-container"></div>
